// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     TextField,
//     Button,
//     IconButton,
//     InputAdornment,
//     Box,
//     Typography,
//     CircularProgress,
// } from "@mui/material";
// import { Visibility, VisibilityOff, Send } from "@mui/icons-material";
// import CloseIcon from "@mui/icons-material/Close";
// // import apiClient from "../api/axiosClient"; // Uncomment when API is ready
// import RegisterModal from "./RegisterModal";
// // import { getUserDetails } from "../common";

// // Configuration flag - set to true when API is ready
// const USE_API = false;

// const PASSWORD_RESET_ENDPOINT = "/auth/password/reset/";
// const OTP_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

// // Static credentials configuration
// const STATIC_CREDENTIALS = {
//     user: { email: "user@demo.com", password: "user123", role: "user" },
//     admin: { email: "admin@demo.com", password: "admin123", role: "admin" }
// };

// const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
//     const [visible, setVisible] = useState(false);

//     useEffect(() => {
//         if (open) {
//             const t = setTimeout(() => setVisible(true), 10);
//             const hide = setTimeout(() => {
//                 setVisible(false);
//                 setTimeout(() => onClose && onClose(), 300);
//             }, 6000);
//             return () => {
//                 clearTimeout(t);
//                 clearTimeout(hide);
//             };
//         } else {
//             setVisible(false);
//         }
//     }, [open, onClose]);

//     if (!open && !visible) return null;

//     const palette = {
//         success: {
//             bg: "linear-gradient(135deg,#7ee787,#28c76f)",
//             accent: "#0a7a3b",
//             text: "#062b18",
//         },
//         error: {
//             bg: "linear-gradient(135deg,#ff9a9e,#ff6b6b)",
//             accent: "#660000",
//             text: "#3b0f0f",
//         },
//         warning: {
//             bg: "linear-gradient(135deg,#ffd89b,#ffb347)",
//             accent: "#7a4300",
//             text: "#3b2a00",
//         },
//         info: {
//             bg: "linear-gradient(135deg,#a1c4fd,#c2e9fb)",
//             accent: "#174ea6",
//             text: "#07203a",
//         },
//     }[severity] || {
//         bg: "linear-gradient(135deg,#e0e0e0,#bdbdbd)",
//         accent: "#333",
//         text: "#111",
//     };

//     const containerStyle = {
//         position: "fixed",
//         left: "50%",
//         top: "28px",
//         transform: `translateX(-50%) translateY(${visible ? "0" : "18px"})`,
//         opacity: visible ? 1 : 0,
//         transition: "transform 260ms cubic-bezier(.2,.9,.2,1), opacity 260ms ease",
//         zIndex: 1400,
//         minWidth: "260px",
//         maxWidth: "92%",
//         boxShadow: "0 12px 40px rgba(11,22,40,0.28)",
//         borderRadius: "14px",
//         overflow: "hidden",
//         display: "flex",
//         alignItems: "center",
//         gap: "12px",
//         padding: "12px 16px",
//         background: palette.bg,
//         color: palette.text,
//         fontFamily: "Inter, Roboto, sans-serif",
//         border: `1px solid rgba(255,255,255,0.08)`,
//         backdropFilter: "blur(6px)",
//     };

//     const iconCircle = {
//         width: 42,
//         height: 42,
//         borderRadius: 10,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "rgba(255,255,255,0.12)",
//         flexShrink: 0,
//     };

//     const titleStyle = {
//         fontSize: 13,
//         fontWeight: 700,
//         color: palette.accent,
//         letterSpacing: "0.2px",
//     };

//     const messageStyle = {
//         fontSize: 13,
//         color: palette.text,
//         opacity: 0.95,
//         marginTop: 6,
//         maxWidth: 520,
//         wordBreak: "break-word",
//     };

//     const closeBtnStyle = {
//         marginLeft: "12px",
//         border: "none",
//         background: "transparent",
//         cursor: "pointer",
//         padding: 6,
//         borderRadius: 8,
//         color: "rgba(0,0,0,0.6)",
//     };

//     const titleMap = {
//         success: "Success",
//         error: "Error",
//         warning: "Warning",
//         info: "Info",
//     };

//     return (
//         <div role="status" aria-live="polite" style={containerStyle}>
//             <div style={iconCircle}>
//                 <div style={{ fontSize: 18, fontWeight: 700, color: palette.accent }}>
//                     {severity === "success"
//                         ? "✓"
//                         : severity === "error"
//                             ? "!"
//                             : severity === "warning"
//                                 ? "!"
//                                 : "i"}
//                 </div>
//             </div>

//             <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//                 <div style={titleStyle}>{titleMap[severity] || "Notice"}</div>
//                 <div style={messageStyle}>{message}</div>
//             </div>

//             <button
//                 aria-label="close message"
//                 onClick={() => {
//                     setVisible(false);
//                     setTimeout(() => onClose && onClose(), 260);
//                 }}
//                 style={closeBtnStyle}
//             >
//                 <CloseIcon fontSize="small" />
//             </button>
//         </div>
//     );
// };

// const LoginModal = ({ type, onClose, onLoginSuccess, onRegisterClick }) => {
//     const [showPassword, setShowPassword] = useState(false);
//     const [showRegisterModal, setShowRegisterModal] = useState(false);
//     const [formData, setFormData] = useState({ email: "", password: "" });
//     const [loading, setLoading] = useState(false);

//     // Forgot password states
//     const [showForgot, setShowForgot] = useState(false);
//     const [fpEmail, setFpEmail] = useState("");
//     const [otpSent, setOtpSent] = useState(false);
//     const [otpValue, setOtpValue] = useState("");
//     const [otpLoading, setOtpLoading] = useState(false);
//     const [otpVerified, setOtpVerified] = useState(false);
//     const [otpGeneratedAt, setOtpGeneratedAt] = useState(null);
//     const otpExpiryTimerRef = useRef(null);

//     const [newPassword, setNewPassword] = useState("");
//     const [confirmNewPassword, setConfirmNewPassword] = useState("");

//     const [showNewPassword, setShowNewPassword] = useState(false);
//     const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
//     const [rememberMe, setRememberMe] = useState(false);
//     const [resendTimer, setResendTimer] = useState(0);

//     useEffect(() => {
//         let timer = null;
//         if (resendTimer > 0) {
//             timer = setInterval(
//                 () => setResendTimer((t) => Math.max(0, t - 1)),
//                 1000
//             );
//         }
//         return () => clearInterval(timer);
//     }, [resendTimer]);

//     const [snack, setSnack] = useState({
//         open: false,
//         severity: "info",
//         message: "",
//     });
//     const snackTimerRef = useRef(null);

//     const showSnack = useCallback(({ severity = "info", message = "" }) => {
//         if (snackTimerRef.current) {
//             clearTimeout(snackTimerRef.current);
//             snackTimerRef.current = null;
//         }
//         setSnack({ open: true, severity, message });
//         snackTimerRef.current = setTimeout(() => {
//             setSnack((s) => ({ ...s, open: false }));
//             snackTimerRef.current = null;
//         }, 6000);
//     }, []);

//     useEffect(() => {
//         return () => {
//             if (snackTimerRef.current) {
//                 clearTimeout(snackTimerRef.current);
//                 snackTimerRef.current = null;
//             }
//             if (otpExpiryTimerRef.current) {
//                 clearTimeout(otpExpiryTimerRef.current);
//                 otpExpiryTimerRef.current = null;
//             }
//         };
//     }, []);

//     // Helper function to check static credentials
//     const checkStaticLogin = (email, password) => {
//         const trimmedEmail = email.trim().toLowerCase();
//         const trimmedPassword = password.trim();

//         for (const [key, cred] of Object.entries(STATIC_CREDENTIALS)) {
//             if (cred.email.toLowerCase() === trimmedEmail && cred.password === trimmedPassword) {
//                 return cred.role;
//             }
//         }
//         return null;
//     };

//     // Static login handler
//     const handleStaticLogin = (email, password) => {
//         const role = checkStaticLogin(email, password);

//         if (role) {
//             showSnack({
//                 severity: "success",
//                 message: `Welcome ${role === "admin" ? "Admin" : "User"}!`,
//             });

//             // Store basic info in sessionStorage
//             sessionStorage.setItem("user_role", role);
//             sessionStorage.setItem("user_email", email);
//             sessionStorage.setItem("user_info", JSON.stringify({
//                 email,
//                 user_role: role
//             }));

//             setTimeout(() => {
//                 onLoginSuccess(role);
//                 onClose();
//             }, 500);

//             return true;
//         }

//         showSnack({
//             severity: "error",
//             message: "Invalid email or password.",
//         });
//         return false;
//     };

//     // API login handler (will be used when USE_API = true)
//     const handleApiLogin = async (email, password) => {
//         try {
//             // Uncomment when apiClient is available
//             /*
//             const res = await apiClient.post("/auth/login/", {
//               email: email,
//               password: password,
//             });

//             const { access, refresh } = res.data;
//             if (access) {
//               sessionStorage.setItem("access_token", access);
//               sessionStorage.setItem("refresh_token", refresh || "");
//               sessionStorage.setItem(
//                 "user_info",
//                 JSON.stringify(res.data.user || {})
//               );
//               if (apiClient.defaults.headers) {
//                 apiClient.defaults.headers.common = apiClient.defaults.headers.common || {};
//                 apiClient.defaults.headers.common["Authorization"] = `Bearer ${access}`;
//               }
//             }

//             if (getUserDetails()) {
//               onLoginSuccess(getUserDetails().user_role);
//               onClose();
//               return true;
//             }

//             onLoginSuccess(res.data);
//             onClose();
//             return true;
//             */

//             // Placeholder for when API is not ready
//             throw new Error("API not configured yet");
//         } catch (err) {
//             const data = err.response?.data;
//             const status = err.response?.status;

//             if (data && typeof data === "object") {
//                 if (data.email) {
//                     showSnack({
//                         severity: "error",
//                         message: "Your user id / mail id is wrong – please check.",
//                     });
//                     return false;
//                 }
//                 if (data.password) {
//                     showSnack({
//                         severity: "error",
//                         message: "Password is wrong for this email – please check.",
//                     });
//                     return false;
//                 }
//                 const nf = data.non_field_errors || data.detail || data.error || null;
//                 if (nf) {
//                     const nfString = Array.isArray(nf) ? nf.join(" ") : String(nf);
//                     showSnack({ severity: "error", message: nfString });
//                     return false;
//                 }
//             }

//             if (status === 401) {
//                 showSnack({
//                     severity: "error",
//                     message: "Email or password is incorrect – please check and try again.",
//                 });
//                 return false;
//             }

//             const fallback = err.response?.data?.detail || err.message || "Login failed.";
//             showSnack({ severity: "error", message: `Login failed: ${fallback}` });
//             return false;
//         }
//     };

//     // Main login handler
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const { email, password } = formData;

//         try {
//             if (USE_API) {
//                 // Use API when available
//                 await handleApiLogin(email, password);
//             } else {
//                 // Use static credentials
//                 handleStaticLogin(email, password);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Forgot password handlers (will work with API)
//     const handleSendOtp = async () => {
//         if (!USE_API) {
//             showSnack({
//                 severity: "info",
//                 message: "Password reset feature will be available when API is connected.",
//             });
//             return;
//         }

//         if (!fpEmail) {
//             return showSnack({
//                 severity: "warning",
//                 message: "Enter your registered email.",
//             });
//         }

//         setOtpLoading(true);
//         // Add API call here when ready
//         setOtpLoading(false);
//     };

//     const handleLocalVerifyOtp = async () => {
//         if (!USE_API) {
//             showSnack({
//                 severity: "info",
//                 message: "OTP verification will be available when API is connected.",
//             });
//             return;
//         }
//         // Add API call here when ready
//     };

//     const handleResetPassword = async () => {
//         if (!USE_API) {
//             showSnack({
//                 severity: "info",
//                 message: "Password reset will be available when API is connected.",
//             });
//             return;
//         }
//         // Add API call here when ready
//     };

//     return (
//         <>
//             <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
//                 <DialogTitle
//                     sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                     }}
//                 >
//                     <Typography variant="h6">
//                         {type === "admin" ? "Admin Login" : "User Login"}
//                     </Typography>
//                     <IconButton onClick={onClose}>
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>

//                 <DialogContent dividers>
//                     {!showForgot ? (
//                         <Box
//                             component="form"
//                             onSubmit={handleSubmit}
//                             sx={{ display: "grid", gap: 2 }}
//                         >

//                             <TextField
//                                 label="Email Address"
//                                 variant="outlined"
//                                 required
//                                 fullWidth
//                                 value={formData.email}
//                                 onChange={(e) =>
//                                     setFormData((p) => ({ ...p, email: e.target.value }))
//                                 }
//                             />

//                             <TextField
//                                 label="Password"
//                                 variant="outlined"
//                                 required
//                                 type={showPassword ? "text" : "password"}
//                                 fullWidth
//                                 value={formData.password}
//                                 onChange={(e) =>
//                                     setFormData((p) => ({ ...p, password: e.target.value }))
//                                 }
//                                 InputProps={{
//                                     endAdornment: (
//                                         <InputAdornment position="end">
//                                             <IconButton
//                                                 onClick={() => setShowPassword((s) => !s)}
//                                                 edge="end"
//                                             >
//                                                 {showPassword ? <VisibilityOff /> : <Visibility />}
//                                             </IconButton>
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                             />
//                             {!USE_API && (
//                                 <Box
//                                     sx={{
//                                         p: 1,
//                                         bgcolor: "#f0f7ff",
//                                         borderRadius: 1,
//                                         border: "1px solid #b3d9ff",
//                                     }}
//                                 >
//                                     <Typography variant="caption" sx={{ fontWeight: 600, display: "block", mb: 1 }}>
//                                         Demo Credentials :
//                                     </Typography>
//                                     <Typography variant="caption" sx={{ display: "block", color: "#1976d2" }}>
//                                         User: user@demo.com / user123
//                                     </Typography>
//                                     <Typography variant="caption" sx={{ display: "block", color: "#9c27b0" }}>
//                                         Admin: admin@demo.com / admin123
//                                     </Typography>
//                                 </Box>
//                             )}
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                 }}
//                             >
//                                 <label
//                                     style={{ display: "flex", alignItems: "center", gap: 8 }}
//                                 >
//                                     <input
//                                         type="checkbox"
//                                         className="checkbox"
//                                         checked={rememberMe}
//                                         onChange={(e) => setRememberMe(e.target.checked)}
//                                     />
//                                     <span style={{ fontSize: 14 }}>Remember me</span>
//                                 </label>

//                                 <Button
//                                     variant="text"
//                                     onClick={() => {
//                                         setShowForgot(true);
//                                         setFpEmail(formData.email || "");
//                                     }}
//                                 //   disabled={!USE_API}
//                                 >
//                                     Forgot password?
//                                 </Button>
//                             </Box>

//                             <Button
//                                 type="submit"
//                                 variant="contained"
//                                 color={type === "admin" ? "secondary" : "primary"}
//                                 disabled={loading}
//                                 startIcon={loading ? <CircularProgress size={18} /> : null}
//                             >
//                                 {loading ? "Signing In..." : "Sign In"}
//                             </Button>
//                         </Box>
//                     ) : (
//                         <Box sx={{ display: "grid", gap: 2 }}>
//                             <Typography variant="subtitle1">Forgot Password</Typography>
//                             <Typography variant="caption" color="warning.main">
//                                 This feature requires API connection
//                             </Typography>
//                         </Box>
//                     )}
//                 </DialogContent>

//                 <DialogActions sx={{ px: 3, py: 2 }}>
//                     {!showForgot ? (
//                         <>
//                             <Button variant="outlined" onClick={onClose} color="inherit">
//                                 Close
//                             </Button>
//                             <Button
//                                 onClick={() => setShowRegisterModal(true)}
//                                 variant="contained"
//                                 color="primary"
//                             // disabled={!USE_API}
//                             >
//                                 Register
//                                 {/* {!USE_API && "(API Required)"} */}
//                             </Button>
//                         </>
//                     ) : (
//                         <Button
//                             onClick={() => setShowForgot(false)}
//                             sx={{
//                                 backgroundColor: "#1976d2",
//                                 color: "white",
//                                 fontWeight: 500,
//                                 "&:hover": { backgroundColor: "#1565c0" },
//                             }}
//                         >
//                             Back to Login
//                         </Button>
//                     )}
//                 </DialogActions>
//             </Dialog>

//             {/* {showRegisterModal && USE_API && ( */}
//             {showRegisterModal && (

//                 <RegisterModal
//                     onClose={() => setShowRegisterModal(false)}
//                     onRegisterSuccess={() => {
//                         setShowRegisterModal(false);
//                         showSnack({
//                             severity: "success",
//                             message: "Registration successful! Please log in.",
//                         });
//                     }}
//                 />
//             )}

//             <MessageCard
//                 open={snack.open}
//                 severity={snack.severity}
//                 message={snack.message}
//                 onClose={() => setSnack((s) => ({ ...s, open: false }))}
//             />
//         </>
//     );
// };

// export default LoginModal;

// import React, { useState } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   TextField, Button, IconButton, InputAdornment,
//   Box, Typography, CircularProgress
// } from "@mui/material";
// import { Visibility, VisibilityOff, Close } from "@mui/icons-material";
// import api from "../service/axios_config";
// import RegisterModal from "./RegisterModal";

// /* ---------- MessageCard ---------- */
// const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
//   if (!open) return null;

//   const colors = {
//     success: "#1e7e34",
//     error: "#c82333",
//     warning: "#856404",
//     info: "#0c5460",
//   };

//   return (
//     <Box
//       sx={{
//         position: "fixed",
//         top: 20,
//         left: "50%",
//         transform: "translateX(-50%)",
//         bgcolor: "#fff",
//         px: 3,
//         py: 1.5,
//         borderRadius: 2,
//         boxShadow: 3,
//         zIndex: 2000,
//         borderLeft: `6px solid ${colors[severity]}`,
//       }}
//     >
//       <Typography color={colors[severity]}>{message}</Typography>
//       <IconButton size="small" onClick={onClose} sx={{ position: "absolute", top: 4, right: 4 }}>
//         <Close fontSize="small" />
//       </IconButton>
//     </Box>
//   );
// };

// const LoginModal = ({ type, onClose, onLoginSuccess }) => {
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [showRegisterModal, setShowRegisterModal] = useState(false);
//   const [snack, setSnack] = useState({ open: false, severity: "info", message: "" });

//   const showMessage = (severity, message) =>
//     setSnack({ open: true, severity, message });

//   /* ================= LOGIN ================= */
//   const handleLogin = async (e) => {
//     e.preventDefault();

//     if (!formData.email || !formData.password) {
//       showMessage("warning", "Email and password are required");
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await api.post("/auth/login/", {
//         email: formData.email,
//         password: formData.password,
//       });

//       const { access, refresh, user } = res.data;

//       // 🔐 Save auth
//       localStorage.setItem("access", access);
//       localStorage.setItem("refresh", refresh);
//       localStorage.setItem("authUser", JSON.stringify(user));
//       localStorage.setItem("user_role", user.role || user.user_role || "");
//       localStorage.setItem("isLogin", "true");
//       localStorage.setItem("user_email", user.email || formData.email);

//       showMessage("success", "Login successful 🎉");

//       setTimeout(() => {
//         onLoginSuccess?.(user);
//         onClose?.();
//       }, 700);

//     } catch (err) {
//       showMessage(
//         "error",
//         err.response?.data?.error || "Invalid email or password"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open fullWidth maxWidth="sm">
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
//           <Typography variant="h6">
//             {type === "admin" ? "Admin Login" : "User Login"}
//           </Typography>
//           <IconButton onClick={onClose}><Close /></IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           <Box component="form" onSubmit={handleLogin} sx={{ display: "grid", gap: 2.5 }}>
//             <TextField
//               label="Email"
//               fullWidth
//               required
//               value={formData.email}
//               onChange={(e) => setFormData(p => ({ ...p, email: e.target.value }))}
//             />

//             <TextField
//               label="Password"
//               fullWidth
//               required
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={(e) => setFormData(p => ({ ...p, password: e.target.value }))}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Button
//               type="submit"
//               variant="contained"
//               disabled={loading}
//               startIcon={loading && <CircularProgress size={20} />}
//             >
//               Login
//             </Button>
//           </Box>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={onClose}>Close</Button>
//           <Button variant="contained" onClick={() => setShowRegisterModal(true)}>
//             Register
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {showRegisterModal && (
//         <RegisterModal
//           onClose={() => setShowRegisterModal(false)}
//           onRegisterSuccess={() =>
//             showMessage("success", "Registration successful! Please login.")
//           }
//         />
//       )}

//       <MessageCard
//         open={snack.open}
//         severity={snack.severity}
//         message={snack.message}
//         onClose={() => setSnack(s => ({ ...s, open: false }))}
//       />
//     </>
//   );
// };

// export default LoginModal;

// LoginModal.jsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Send,
  Close as CloseIcon,
} from "@mui/icons-material";
import api from "../service/axios_config";
import RegisterModal from "./RegisterModal";

/* ================= CONFIG ================= */
const PASSWORD_RESET_ENDPOINT = "/auth/password/reset/";
const OTP_EXPIRY_MS = 5 * 60 * 1000;

/* ================= MESSAGE CARD ================= */
const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
  if (!open) return null;

  const colors = {
    success: "#2e7d32",
    error: "#d32f2f",
    warning: "#ed6c02",
    info: "#0288d1",
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 24,
        left: "50%",
        transform: "translateX(-50%)",
        background: "#fff",
        px: 3,
        py: 1.5,
        borderRadius: 2,
        boxShadow: 6,
        zIndex: 2000,
        borderLeft: `6px solid ${colors[severity]}`,
        minWidth: 300,
      }}
    >
      <Typography sx={{ color: colors[severity], fontWeight: 500 }}>
        {message}
      </Typography>
      <IconButton
        size="small"
        onClick={onClose}
        sx={{ position: "absolute", top: 4, right: 4 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

/* ================= LOGIN MODAL ================= */
const LoginModal = ({ type, onClose, onLoginSuccess }) => {
  /* ---------- Login ---------- */
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ---------- Forgot Password ---------- */
  const [showForgot, setShowForgot] = useState(false);
  const [fpEmail, setFpEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpGeneratedAt, setOtpGeneratedAt] = useState(null);
  const otpExpiryRef = useRef(null);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  /* ---------- Register ---------- */
  const [showRegister, setShowRegister] = useState(false);

  /* ---------- Snackbar ---------- */
  const [snack, setSnack] = useState({
    open: false,
    severity: "info",
    message: "",
  });

  const showSnack = useCallback((severity, message) => {
    setSnack({ open: true, severity, message });
  }, []);

  /* ================= LOGIN ================= */
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      showSnack("warning", "Email and password are required");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/auth/login/", formData);
      const { access, refresh, user } = res.data;

      // Always sessionStorage only — no localStorage
      sessionStorage.setItem("access", access);
      sessionStorage.setItem("refresh", refresh || "");
      sessionStorage.setItem("user", JSON.stringify(user || {}));
      console.log("LOGIN RESPONSE:", res.data);
      console.log("AFTER SAVE:", sessionStorage.getItem("access"));
      showSnack("success", "Login successful");
      setTimeout(() => {
        // Pass tokens so AuthContext can store them
        onLoginSuccess?.(user, access, refresh);
        onClose();
      }, 600);
    } catch (err) {
      showSnack("error", err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  /* ================= OTP ================= */
  const sendOtp = async () => {
    if (!fpEmail) return showSnack("warning", "Enter your registered email");

    setOtpLoading(true);
    try {
      await api.post("/otp/generate/", {
        email: fpEmail,
        purpose: "password_reset",
      });
      setOtpSent(true);
      setOtpGeneratedAt(Date.now());
      setOtpVerified(false);

      otpExpiryRef.current = setTimeout(() => {
        setOtpVerified(false);
      }, OTP_EXPIRY_MS);

      showSnack("success", "OTP sent to your email");
    } catch (err) {
      showSnack("error", err.response?.data?.detail || "Failed to send OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (otpValue.length !== 6) return showSnack("warning", "Enter 6-digit OTP");

    setOtpLoading(true);
    try {
      await api.post("/otp/validate/", {
        email: fpEmail,
        otp: otpValue,
      });
      setOtpVerified(true);
      showSnack("success", "OTP verified");
    } catch {
      showSnack("error", "Invalid OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  /* ================= RESET PASSWORD ================= */
  const resetPassword = async () => {
    if (!otpVerified) return showSnack("warning", "Verify OTP first");

    if (newPassword !== confirmPassword)
      return showSnack("error", "Passwords do not match");

    setOtpLoading(true);
    try {
      await api.post(PASSWORD_RESET_ENDPOINT, {
        email: fpEmail,
        otp: otpValue,
        new_password: newPassword,
      });
      showSnack("success", "Password reset successful");
      setShowForgot(false);
    } catch (err) {
      showSnack("error", err.response?.data?.detail || "Reset failed");
    } finally {
      setOtpLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <>
      <Dialog open fullWidth maxWidth="sm">
        <DialogTitle>
          {type === "admin" ? "Login" : "Login"}
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {!showForgot ? (
            <Box
              component="form"
              onSubmit={handleLogin}
              sx={{ display: "grid", gap: 2 }}
            >
              <TextField
                label="Email"
                fullWidth
                value={formData.email}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, email: e.target.value }))
                }
              />
              <TextField
                label="Password"
                fullWidth
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, password: e.target.value }))
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword((s) => !s)}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={() => setShowForgot(true)}>
                  Forgot password?
                </Button>
              </Box>

              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={18} /> : "Login"}
              </Button>
            </Box>
          ) : (
            <Box sx={{ display: "grid", gap: 2 }}>
              <TextField
                label="Registered Email"
                value={fpEmail}
                onChange={(e) => setFpEmail(e.target.value)}
              />
              <Button onClick={sendOtp} startIcon={<Send />}>
                Send OTP
              </Button>

              {otpSent && (
                <>
                  <TextField
                    label="OTP"
                    value={otpValue}
                    onChange={(e) =>
                      setOtpValue(e.target.value.replace(/\D/g, ""))
                    }
                  />
                  <Button onClick={verifyOtp}>Verify OTP</Button>

                  <TextField
                    label="New Password"
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <TextField
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <Button variant="contained" onClick={resetPassword}>
                    Reset Password
                  </Button>
                </>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          {!showForgot && (
            <Button onClick={() => setShowRegister(true)}>Register</Button>
          )}
        </DialogActions>
      </Dialog>

      {showRegister && <RegisterModal onClose={() => setShowRegister(false)} />}

      <MessageCard
        open={snack.open}
        severity={snack.severity}
        message={snack.message}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      />
    </>
  );
};

export default LoginModal;
